export default __webpack_public_path__ + "static/media/cancel.56e899ff.svg";